"use client";

// Tool-Favicons als Ambient-Hintergrund für Status-Quo.
// Sanfte "Planeten"-Drift: jedes Icon bekommt einen eigenen Orbit (andere Amplitude,
// Dauer und Phase), damit das Set organisch wirkt statt synchron zu pulsieren.

type Tool = {
  domain: string;
  size: number;
  displaySize: number;
  pos: { x: number; y: number };
  orbit: { dx: number; dy: number; dur: number; delay: number };
};

const TOOLS: Tool[] = [
  { domain: "outlook.office.com",  size: 64, displaySize: 34, pos: { x: 6,  y: 18 }, orbit: { dx: 40, dy: 28, dur: 16, delay: 0 } },
  { domain: "office.com",          size: 64, displaySize: 39, pos: { x: 24, y: 10 }, orbit: { dx: 32, dy: 42, dur: 19, delay: 3 } },
  { domain: "teams.microsoft.com", size: 64, displaySize: 28, pos: { x: 45, y: 20 }, orbit: { dx: 48, dy: 24, dur: 17, delay: 6 } },
  { domain: "sharepoint.com",      size: 64, displaySize: 31, pos: { x: 68, y: 12 }, orbit: { dx: 36, dy: 36, dur: 21, delay: 2 } },
  { domain: "feedly.com",          size: 64, displaySize: 27, pos: { x: 88, y: 22 }, orbit: { dx: 28, dy: 40, dur: 15, delay: 5 } },
  { domain: "clickup.com",         size: 64, displaySize: 36, pos: { x: 14, y: 52 }, orbit: { dx: 44, dy: 26, dur: 22, delay: 1 } },
  { domain: "notion.so",           size: 64, displaySize: 29, pos: { x: 38, y: 46 }, orbit: { dx: 34, dy: 44, dur: 18, delay: 7 } },
  { domain: "slack.com",           size: 64, displaySize: 35, pos: { x: 62, y: 54 }, orbit: { dx: 38, dy: 32, dur: 20, delay: 4 } },
  { domain: "buffer.com",          size: 64, displaySize: 28, pos: { x: 84, y: 50 }, orbit: { dx: 30, dy: 46, dur: 16, delay: 8 } },
  { domain: "docs.google.com",     size: 64, displaySize: 32, pos: { x: 28, y: 82 }, orbit: { dx: 42, dy: 30, dur: 23, delay: 2 } },
  { domain: "hootsuite.com",       size: 64, displaySize: 27, pos: { x: 52, y: 86 }, orbit: { dx: 34, dy: 40, dur: 14, delay: 6 } },
  { domain: "airtable.com",        size: 64, displaySize: 31, pos: { x: 78, y: 84 }, orbit: { dx: 46, dy: 28, dur: 24, delay: 0 } },
];

function faviconUrl(domain: string, size = 128) {
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=${size}`;
}

export function StatusQuoTools() {
  return (
    <div
      aria-hidden
      className="absolute inset-0 pointer-events-none overflow-hidden"
      style={{ opacity: 0.45 }}
    >
      <style>{`
        @keyframes orbit-drift {
          0%   { transform: translate(-50%, -50%) translate(0, 0) scale(1); }
          25%  { transform: translate(-50%, -50%) translate(var(--dx), calc(var(--dy) * -0.6)) scale(1.25); }
          50%  { transform: translate(-50%, -50%) translate(calc(var(--dx) * 0.3), var(--dy)) scale(0.75); }
          75%  { transform: translate(-50%, -50%) translate(calc(var(--dx) * -0.8), calc(var(--dy) * 0.4)) scale(1.15); }
          100% { transform: translate(-50%, -50%) translate(0, 0) scale(1); }
        }
        @media (prefers-reduced-motion: reduce) {
          .orbit-planet { animation: none !important; }
        }
      `}</style>
      {TOOLS.map((t) => (
        <img
          key={t.domain}
          src={faviconUrl(t.domain, t.size)}
          alt=""
          width={t.displaySize}
          height={t.displaySize}
          loading="lazy"
          className="orbit-planet absolute rounded-md"
          style={{
            left: `${t.pos.x}%`,
            top: `${t.pos.y}%`,
            transform: "translate(-50%, -50%)",
            willChange: "transform",
            animation: `orbit-drift ${t.orbit.dur}s ease-in-out ${t.orbit.delay}s infinite`,
            ["--dx" as string]: `${t.orbit.dx}px`,
            ["--dy" as string]: `${t.orbit.dy}px`,
          }}
        />
      ))}
    </div>
  );
}
